/**
 * Turn a path built at runtime (a component's `url` prop, a path from a
 * payload) into an absolute path on the API origin. Crema's routes already
 * carry their `api/` prefix (`api/work`, `api/cemetery-for-select`), so the
 * path is only anchored to the origin root.
 *
 * @param {string} path
 * @returns {string}
 */
export function apiPath(path) {
  const pathText = String(path)

  if (/^(https?:)?\/\//.test(pathText)) {
    return pathText
  }

  return `/${pathText.replace(/^\/+/, '')}`
}
